var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchasePoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#285680",
    d: "M50 53.76V54a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V28a4 4 0 0 1 4-4h3.1l37.48 26 2.88 2z",
    opacity: 1,
    "data-original": "#285680",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c3e50",
    d: "M47.46 52H0v-2h44.58z",
    opacity: 1,
    "data-original": "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4482c3",
    d: "m57.91 25.39-4.54 21.52-.42 1.96-.41 1.96a4 4 0 0 1-4.74 3.08L6.71 45.23a4 4 0 0 1-3.09-4.74l.41-1.95.42-1.96 4.54-21.53v-.02l24.85 1.19 20.99 4.43a3.991 3.991 0 0 1 3.08 4.74z",
    opacity: 1,
    "data-original": "#4482c3",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#285680",
    d: "m53.37 46.91-.42 1.96L4.03 38.54l.42-1.96z",
    opacity: 1,
    "data-original": "#285680",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    x: 42.095,
    y: 24.214,
    fill: "#f29c1f",
    rx: 2,
    transform: "scale(-1) rotate(11.95 269.56 -450.152)",
    opacity: 1,
    "data-original": "#f29c1f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f3d55b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.128 39.052a.994.994 0 0 1-.208-.022l-17.611-3.72a1 1 0 0 1 .414-1.957l17.611 3.72a1 1 0 0 1-.206 1.979zM49.3 42.965c-.07 0-.14-.007-.208-.021l-8.806-1.861a1 1 0 0 1 .414-1.957l8.806 1.861a1 1 0 0 1-.206 1.978zM23.964 1.279l2.95 6.215a2.208 2.208 0 0 0 1.652 1.256l6.545.989a2.351 2.351 0 0 1 1.21 3.962l-4.695 4.758a2.4 2.4 0 0 0-.642 2.067l1.116 6.752a2.223 2.223 0 0 1-3.174 2.453L23.01 26.5a2.1 2.1 0 0 0-2.02 0l-5.914 3.232a2.223 2.223 0 0 1-3.176-2.454l1.114-6.752a2.4 2.4 0 0 0-.642-2.067L7.679 13.7a2.351 2.351 0 0 1 1.21-3.962l6.545-.989a2.208 2.208 0 0 0 1.652-1.256l2.95-6.215a2.148 2.148 0 0 1 3.928.001z",
    fill: "#f3d55b",
    opacity: 1,
    "data-original": "#f3d55b",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f0c419",
    d: "M31.629 18.458a2.415 2.415 0 0 0-.65 2.069l1.12 6.75a2.229 2.229 0 0 1-3.18 2.459L23.01 26.5c-.63-.34-1.39-.34-2.02 0l-5.909 3.239a2.229 2.229 0 0 1-3.18-2.459l.25-1.49C27 16.808 24.69 4.639 23.34.47c.264.22.476.498.62.81l2.949 6.22a2.238 2.238 0 0 0 1.66 1.25l6.539.99a2.349 2.349 0 0 1 1.21 3.959z",
    opacity: 1,
    "data-original": "#f0c419",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchasePoints);
export default __webpack_public_path__ + "static/media/purchase_points.f93e53afa8537019e67882c5fb7598c9.svg";
export { ForwardRef as ReactComponent };